import React from 'react';

const StatusBadge = ({ status }) => {
  const getStatusBadge = (status) => {
    switch (status) {
      case 'I':
        return <span className="badge badge-pill badge-soft-pending font-size-11">Initiated</span>;
      case 'A':
        return <span className="badge badge-pill badge-soft-success font-size-11">Completed</span>;
      case 'RA':
        return <span className="badge badge-pill badge-soft-warning font-size-11">Raised</span>;
      case 'RM':
        return <span className="badge badge-pill badge-soft-warning font-size-11">Merchant Raised</span>;
      case 'R':
        return <span className="badge badge-pill badge-soft-danger font-size-11">Rejected</span>;
      case 'MC':
        return <span className="badge badge-pill badge-soft-danger font-size-11">Cancelled</span>;
      case 'E':
        return <span className="badge badge-pill badge-soft-warning font-size-11">Expired</span>;
      case 'F':
        return <span className="badge badge-pill badge-soft-danger font-size-11">Failed</span>;
      case 'P':
        return <span className="badge badge-pill badge-soft-pending font-size-11">Pending</span>;
      case 'AA':
        return <span className="badge badge-pill badge-soft-warning font-size-11">Pending</span>;
      case 'AR':
        return <span className="badge badge-pill badge-soft-danger font-size-11">Rejected</span>;
      case 'RF':
        return <span className="badge badge-pill badge-soft-warning font-size-11">Refund</span>;
      case 'C':
        return <span className="badge badge-pill badge-soft-success font-size-11">Paid</span>;
        case 'AN':
        return <span className="badge badge-pill badge-soft-success font-size-11">Confirmed</span>;
      default:
        return null;
    }
  };

  return getStatusBadge(status);
};


export default StatusBadge;

export const getStatusClass = (status) => {
  switch (status) {
    case 'Active':
      return 'badge-soft-success';
    case 'Initiated':
      return 'badge-soft-pending';
    case 'Rejected':
      return 'badge-soft-warning';
    case 'Suspended':
        return 'badge-soft-received';
    case 'Deleted':
          return 'badge-soft-danger';
    default:
      return '';
  }
}
